// A bump needs webexCalling.ts checked again against the SDK's dist/types: answer and dial are async, and
// refreshCallback lives in webexConfig.config.credentials.
// Must equal the exact `webex` version pinned in package.json; scripts/copy-webex-calling.js checks it.
export const WEBEX_CALLING_VERSION = "3.12.0";
